import * as React from "react";
import { AuditList } from "../common/AuditList";

const ProductAudit = () => <AuditList resource="products" />;

export default ProductAudit;
